<template>
  <div class="dialog-box">
    <el-dialog :visible.sync="dialogVisible" :title="$t('message.text14')" custom-class="login-dlg" :before-close="onClose">
      <div class="inputArea">
        <label for="userId">
          <span>{{ $t('message.text15') }}</span>
          <input id="userId" v-model="listQuery.account" type="text">
        </label>
        <label for="password">
          <span>{{ $t('message.text16') }}</span>
          <input id="password" v-model="listQuery.password" type="password">
        </label>
        <div :class="['loginContent-btn',locale]" @click="login">{{ $t('message.text14') }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogCustom",
  props:{
    dialogVisible:{
      type:Boolean,
      default: false
    }
  },
  data(){
    return {
      listQuery: {
        account: 'P0001',
        password: 'aaaa1234',
      },
    }
  },
  computed:{
    locale(){
      return this.$i18n.locale
    }
  },
  methods:{
    onClose(){
      this.$emit('close',false)
    },
    async login() {
      const params = {
        ...this.listQuery,
      }
      await this.$store.dispatch('login', params)
      if(this.$store.state.gameToken !== '') {
        this.$emit('onLogin',false)
        this.gameToken = this.$store.state.gameToken
        this.isLogin = true
      } else {
        this.isLogin = false
      }
     this.onClose()
    },
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/dialog.scss";
</style>
